import React from "react";
import { Redirect } from "react-router-dom";

// La pantalla DBA anterior era un stub (métricas LID en 0 y duplicados mal mapeados).
// El flujo operativo está en el gestor de tickets duplicados.
const DBADashboard = () => <Redirect to="/duplicate-tickets" />;

export default DBADashboard;
